import { JSX } from "react";
import { NetworkIntegrityResultsAsOfOption } from "@app/projects/network-assessment/network-integrity/models/networkIntegrityResultsAsOfOption";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface NetworkIntegrityResultsAsOfFilterProps {
  options: NetworkIntegrityResultsAsOfOption[];
  selectedId: string;
  setSelectedId: (value: string) => void;
}

const NetworkIntegrityResultsAsOfFilter = (props: NetworkIntegrityResultsAsOfFilterProps): JSX.Element => {
  const { options, selectedId, setSelectedId } = props;

  const handleChange = (value: string): void => {
    if (value !== selectedId) {
      setSelectedId(value);
    }
  };

  // Gated on the total, not the selectable count: disabling the control would hide the listed-but-disabled
  // timeslices, which exist precisely so the user can see where Network Integrity was not enabled.
  return (
    <QESSelect
      label="Results as of:"
      testId="network-integrity-filters__results-as-of"
      value={selectedId ?? ""}
      onChange={(e) => handleChange(e.target.value)}
      className="network-integrity-filters__results-as-of"
      disabled={options.length <= 1}
    >
      {options.map((option) => (
        <option
          key={`network-integrity-filters__results-as-of-option--${option.id}`}
          value={option.id}
          disabled={option.isDisabled}
        >
          {option.label}
        </option>
      ))}
    </QESSelect>
  );
}

export default NetworkIntegrityResultsAsOfFilter;
